import { createListenCollectionEpic, createListenDocEpic } from 'src/firebase';
import { actions, actionTypes } from './redux';

const ListenMembersEpic$ = createListenCollectionEpic({
  collection: 'members',
  listenType: actionTypes.LISTEN_COLLECTION,
  unlistenType: actionTypes.UNLISTEN_COLLECTION,
  changeCollection: actions.changeCollection,
});

const ListenMemberDetailEpic$ = createListenDocEpic({
  collection: 'members',
  listenType: actionTypes.LISTEN_DOC,
  unlistenType: actionTypes.UNLISTEN_DOC,
  changeDoc: actions.changeDoc,
});

export {
    ListenMembersEpic$,
    ListenMemberDetailEpic$
};



// WEBPACK FOOTER //
// ./src/members/epics.ts